(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('.product-section[data-product-id]').forEach(section => {
      if (section.dataset.zaftBuyingReady) return;
      const form = section.querySelector('form[action*="/cart/add"]');
      const button = form?.querySelector('[data-add-to-cart]');
      const details = section.querySelector('[data-zaft-buying-details]');
      if (!form || !button || !details) return;
      section.dataset.zaftBuyingReady = 'true';
      const sticky = document.createElement('div');
      sticky.className = 'zaft-sticky-buy';
      sticky.hidden = true;
      const label = document.createElement('div');
      label.className = 'zaft-sticky-buy__name';
      const title = document.createElement('span');
      title.textContent = section.dataset.productTitle || section.querySelector('h1')?.textContent.trim() || '';
      const price = document.createElement('span');
      price.className = 'zaft-sticky-buy__price';
      label.append(title, price);
      const action = document.createElement('button');
      action.type = 'button';
      action.className = 'btn';
      action.addEventListener('click', () => { if (!button.disabled) button.click(); });
      sticky.append(label, action);
      section.append(sticky);
      const sync = () => {
        action.disabled = button.disabled;
        action.textContent = button.textContent.trim();
        price.textContent = section.querySelector('[data-product-price]')?.textContent.trim() || '';
      };
      const observer = new MutationObserver(sync);
      observer.observe(button, {attributes:true,childList:true,subtree:true});
      const priceNode = section.querySelector('[data-product-price]');
      if (priceNode) observer.observe(priceNode, {childList:true,subtree:true});
      new IntersectionObserver(entries => {
        const e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }, {threshold:0}).observe(button);
      section.addEventListener('variantChange', event => {
        const variant = event.detail?.variant;
        const node = details.querySelector('[data-zaft-package]');
        const name = variant?.title || '';
        const key = name.includes('Complete Gift Set') ? 'complete' : name.includes('Essential Gift Set') ? 'essential' : name.includes('Rose Box') ? 'rose' : name.includes('Classic') ? 'classic' : '';
        node.hidden = !key;
        node.textContent = key ? details.dataset[key] : '';
        requestAnimationFrame(sync);
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  let cartAttempts = 0;
  function styleCart() {
    const root = document.querySelector('#upCart')?.shadowRoot;
    if (!root) {
      if (++cartAttempts < 80) setTimeout(styleCart, 500);
      return;
    }
    if (!root.querySelector('#zaft-cart-style')) {
      const style = document.createElement('style');
      style.id = 'zaft-cart-style';
      style.textContent = `.upcart-public-header{padding:14px 20px!important;min-height:56px!important}.upcart-public-rewards{padding:12px 20px!important;min-height:0!important}.upcart-public-rewards__message{font-size:13px!important;line-height:1.5!important;font-weight:400!important}.upcart-public-component-product-tile{padding-top:16px!important;padding-bottom:16px!important}.upcart-public-upsell{padding-top:8px!important;padding-bottom:8px!important}.upcart-footer{background:#fff!important;padding:14px 20px!important}.upcart-public-addons__image-wrapper{width:42px!important;height:42px!important;min-width:42px!important}.upcart-public-addons__content-title{font-size:13px!important}.upcart-public-addons__content-description{font-size:11px!important}.upcart-checkout-button{background:#242321!important;color:#fff!important;font-weight:600!important;min-height:48px!important}`;
      root.append(style);
      const reflectCart = () => document.body.classList.toggle('zaft-cart-open', !!root.querySelector('.upcart-cart.styles_active__'));
      new MutationObserver(reflectCart).observe(root, {attributes:true,attributeFilter:['class'],childList:true,subtree:true});
      reflectCart();
    }
  }
  styleCart();
})();
